var exports = {
  "vK": "xfd349460--a4ff21--banner",
  "kZ": "xfd349460--a4ff21--image-wrapper",
  "Qq": "xfd349460--a4ff21--text",
  "s4": "xfd349460--a4ff21--call-button-wrapper",
};

module.exports = exports;
